import { createContext, type ReactNode } from 'react';

// Confirmación imperativa sobre ConfirmModal (reemplaza window.confirm).
// Resuelve true al confirmar y false al cancelar o cerrar. Ver design.md › Modales.
export type ConfirmOptions = {
  title: string;
  message?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  isDestructive?: boolean;
};

export type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>;

export const ConfirmContext = createContext<ConfirmFn | null>(null);
